import {Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({name: 'distance'})
export class DistancePipe implements PipeTransform {

  private static readonly M_IN_KM = 1000;

  constructor(private translate: TranslateService) {
  }

  public transform(value: number, args?: string[]): string {
    if (!value || value <= 0) {
      return '0' + this.translate.instant('unit.km');
    }

    const km = Math.round(value / DistancePipe.M_IN_KM);
    return `${km} ` + this.translate.instant('unit.km');
  }

}
